import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import DashboardView from 'src/views/reports/DashboardView';
import MainLayout from 'src/layouts/MainLayout';
import AccountView from 'src/views/perfil';
import CustomerListView from 'src/views/usuarios/CustomerListView';
import NovoUsuario from 'src/views/usuarios/novo';
import EditarUsuario from 'src/views/usuarios/editar';
import Auth from 'src/views/auth/Auth';
import NotFoundView from 'src/views/errors/NotFoundView';
import Acervos from 'src/views/acervos/';
import NovoAcervo from 'src/views/acervos/novo/';
import EditarAcervo from 'src/views/acervos/editar/';
import Relatorios from 'src/views/relatorios/';
import Mapas from 'src/views/mapas/salas';
import NovaSala from 'src/views/mapas/salas/nova';
import EditarSala from 'src/views/mapas/salas/editar';
import Situacoes from 'src/views/situacoes';
import NovaSituacao from 'src/views/situacoes/nova';
import EditarSituacao from 'src/views/situacoes/editar';
import Registros from 'src/views/registros/';
import Front from 'src/views/front';
import Emprestimos from 'src/views/emprestimos';
import Classificacoes from 'src/views/classificacoes';
import NovaClassificao from 'src/views/classificacoes/nova';
import EditarClassificao from 'src/views/classificacoes/editar';
import Procedencias from 'src/views/procedencias';
import NovaProcedencia from 'src/views/procedencias/nova';
import EditarProcedencia from 'src/views/procedencias/editar';

const routes = (isLoggedIn, permissao) => {
  const todas = [
    { path: 'usuarios', element: <CustomerListView />, permissoes: ['all_admin'] },
    { path: 'usuarios/novo', element: <NovoUsuario />, permissoes: ['all_admin'] },
    { path: 'usuarios/:id', element: <EditarUsuario />, permissoes: ['all_admin'] },
    { path: 'acervos', element: <Acervos />, permissoes: ['list_acervos'] },
    { path: 'relatorios', element: <Relatorios />, permissoes: ['relatorios'] },
    { path: 'registros', element: <Registros />, permissoes: ['list_acervos', 'relatorios'] },
    { path: 'acervos/novo', element: <NovoAcervo />, permissoes: ['create_acervos'] },
    { path: 'acervos/:id', element: <EditarAcervo />, permissoes: ['update_acervos'] },
    { path: 'mapas', element: <Mapas />, permissoes: ['list_mapas'] },
    { path: 'mapas/nova', element: <NovaSala />, permissoes: ['create_mapas'] },
    { path: 'mapas/:id', element: <EditarSala />, permissoes: ['update_mapas'] },
    { path: 'situacoes', element: <Situacoes />, permissoes: ['list_situacoes'] },
    { path: 'situacoes/nova', element: <NovaSituacao />, permissoes: ['create_situacoes'] },
    { path: 'situacoes/:id', element: <EditarSituacao />, permissoes: ['update_situacoes'] },
    { path: 'classificacoes', element: <Classificacoes />, permissoes: ['all_admin'] },
    { path: 'classificacoes/nova', element: <NovaClassificao />, permissoes: ['all_admin'] },
    { path: 'classificacoes/:id', element: <EditarClassificao />, permissoes: ['all_admin'] },
    { path: 'procedencias', element: <Procedencias />, permissoes: ['all_admin'] },
    { path: 'procedencias/nova', element: <NovaProcedencia />, permissoes: ['all_admin'] },
    { path: 'procedencias/:id', element: <EditarProcedencia />, permissoes: ['all_admin'] },
    { path: 'front', element: <Front />, permissoes: ['all_admin'] },
    { path: 'emprestimos', element: <Emprestimos />, permissoes: ['all_admin'] },
  ];
  let rotas = [
    { path: 'perfil', element: <AccountView /> },
    { path: 'dashboard', element: <DashboardView /> },
    { path: 'login', element: <Auth /> },
    { path: '/', element: <Navigate to="/app/dashboard" replace /> },
    { path: '*', element: <Navigate to="/404" /> }
  ];
  if (isLoggedIn && permissao !== null) {
    if (permissao.permissoes !== undefined) {
      switch (permissao.nome) {
        case 'Gestor do Sistema':
          rotas = [
            { path: 'acervos', element: <Acervos /> },
            { path: 'acervos/novo', element: <NovoAcervo /> },
            { path: 'acervos/:id', element: <EditarAcervo /> },
            { path: 'mapas', element: <Mapas /> },
            { path: 'mapas/nova', element: <NovaSala /> },
            { path: 'mapas/:id', element: <EditarSala /> },
            { path: 'relatorios', element: <Relatorios /> },
            { path: 'registros', element: <Registros /> },
            { path: 'situacoes', element: <Situacoes /> },
            { path: 'situacoes/nova', element: <NovaSituacao /> },
            { path: 'situacoes/:id', element: <EditarSituacao /> },
            { path: 'classificacoes', element: <Classificacoes /> },
            { path: 'classificacoes/nova', element: <NovaClassificao /> },
            { path: 'classificacoes/:id', element: <EditarClassificao /> },
            { path: 'procedencias', element: <Procedencias /> },
            { path: 'procedencias/nova', element: <NovaProcedencia /> },
            { path: 'procedencias/:id', element: <EditarProcedencia /> },
            { path: 'perfil', element: <AccountView /> },
            {
              path: 'usuarios',
              element: <CustomerListView />,
            },
            { path: 'usuarios/novo', element: <NovoUsuario /> },
            { path: 'usuarios/:id', element: <EditarUsuario /> },
            { path: 'dashboard', element: <DashboardView /> },
            { path: 'front', element: <Front /> },
            { path: 'emprestimos', element: <Emprestimos /> },
            { path: '*', element: <Navigate to="/404" /> }
          ];
          break;
        default:
          const final = todas.filter((rota) => rota.permissoes.some((p) => permissao.permissoes.includes(p)));
          rotas = rotas.concat(final);
          rotas.push({ path: '*', element: <Navigate to="/404" /> });
          break;
      }
    }
  }
  return [
    {
      path: 'app',
      element: isLoggedIn ? <DashboardLayout /> : <Navigate to="/login" />,
      children: rotas,
    },
    {
      path: '/',
      element: !isLoggedIn ? <MainLayout /> : <Navigate to="/app/dashboard" />,
      children: [
        { path: 'login', element: <Auth /> },
        { path: '404', element: <NotFoundView /> },
        { path: '/', element: <Navigate to="/app/dashboard" /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    }
  ];
};

export default routes;
